var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#073C50",
    fillRule: "evenodd",
    d: "M24,0 C37.254834,0 48,10.745166 48,24 C48,37.254834 37.254834,48 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M24,6 C14.0588745,6 6,14.0588745 6,24 C6,27.8854337 7.23106867,31.4833358 9.32442975,34.4249303 L9.13936863,34.1598894 L9.13936863,34.1598894 C12.621235,29.7959036 17.9841084,27 24,27 C30.0158868,27 35.3787564,29.7958991 38.8600915,34.1591801 C40.8412962,31.2683845 42,27.7695071 42,24 C42,14.0588745 33.9411255,6 24,6 Z M24,11 C27.8659932,11 31,14.1340068 31,18 C31,21.8659932 27.8659932,25 24,25 C20.1340068,25 17,21.8659932 17,18 C17,14.1340068 20.1340068,11 24,11 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.9e779bdc7428c931497354f6bb923084.svg";
export { ForwardRef as ReactComponent };